<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
  >
    <polygon
      points="10.5,3 19.5,7.5 10.5,12 1.5,7.5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linejoin="round"
    />
    <path
      d="M5.5,9.5 L5.5,14.5 C5.5,14.5 7.5,17 10.5,17 C13.5,17 15.5,14.5 15.5,14.5 L15.5,9.5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
    <line
      x1="19.5"
      y1="7.5"
      x2="19.5"
      y2="14"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>
